<template>
  <g>
    <path
      d="M0 0h24v24H0z"
      fill="none"
    /><path
      d="M4 18h16a1 1 0 000-2H4a1 1 0 000 2zm0-5h16a1 1 0 000-2H4a1 1 0 000 2zM3 7a1 1 0 001 1h16a1 1 0 000-2H4a1 1 0 00-1 1z"
      fill="currentColor"
    />
  </g>
</template>
